import React, { useContext, useEffect, useRef, useState } from 'react'
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import Slider from "react-slick";
import { Field, Form, Formik } from 'formik';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { VehicleContext } from '../Components/Context/VehicleContext';
import { getImages, getMakeImages } from '../Components/const';
import Fancybox from '../Components/Common/Fancybox';
import VehicleLogo from '../Components/Common/VehicleLogo';
import { ErrorMessage } from 'formik';
import UseScrollReveal from '../Components/Common/UseScrollReveal ';
import ReCAPTCHA from 'react-google-recaptcha';
import SeoMeta from '../Components/Common/SeoMeta';
import * as Yup from 'yup';
import ValidationError from '../Components/Errors/ValidationError';
import { Helmet } from 'react-helmet';

const vdpList = [
    "Clean CARFAX. Grigio Hati Metallic Optional Stitching",
    "Blue Calipers",
    "Active Cruise Control",
    "Advanced 3D Bang & Olufsen Sound System",
    "Blu Cepheus Seatbelts",
    "Full Leather Heated Sport Steering Wheel",
    "Panoramic Roof",
    "Privacy Glass Acoustic & Heat Insulated",
    "Steering Wheel Stitching",
    "Unicolor Alcantara Seat Upholstery",
    "Wheels: 23 Pelope Shiny Black. 2023 {vehicleData.make} {vehicleData.model}",
    "Performante AWD 8-Speed Automatic 4.0L V8 Twin Turbocharged."
];

const Vdp = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const optionsVdp = {
        responsive: {
            0: {
                items: 2,
                margin: 10
            },
            600: {
                items: 2,
                margin: 20
            },
            768: {
                items: 3,
                margin: 25
            },
            1000: {
                items: 3,
                margin: 25
            }
        },
    };

    const [vehicleVIN, setVehicleVIN] = useState("");

    const { vehiclesByVIN, numberFormatter, priceFormatter, submitContactForm } = useContext(VehicleContext);
    const recaptchaRef = React.useRef();

    const [vehicleData, setVehicleData] = useState({});

    const [vehicleExist, setVehicleExist] = useState(false);

    useEffect(() => {
        if (location && !vehicleVIN && vehiclesByVIN) {
            let vin = location.pathname.slice(location.pathname.lastIndexOf("-") + 1, location.pathname.length);
            if (vin in vehiclesByVIN) setVehicleVIN(vin);
            else navigate("/inventory");

            console.log("vin test", vin);
        }
    }, [location, vehiclesByVIN]);

    useEffect(() => {
        if (vehicleVIN && vehiclesByVIN && vehicleVIN in vehiclesByVIN) {
            var vehicle_data = vehiclesByVIN[vehicleVIN];
            console.log(vehicle_data);
            const split_index = Math.ceil((vehicle_data.images.length - 1) / 2);

            if (split_index > 0) {
                //var gallery_images = vehicle_data.images.slice(1).reduce(function (rows, key, index) {
                //    return (index % 2 == 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows;
                //}, []);
                console.log(vehicle_data.images.length - 1, split_index);
                var gallery_images = vehicle_data.images.slice(1).reduce(function (rows, key, index) {
                    return (index < split_index || vehicle_data.images.length - 1 <= 3 ? rows.push([key]) : rows[index - split_index].push(key)) && rows;
                }, []);
                vehicle_data.gallery_images = gallery_images;
            } else
                vehicle_data.gallery_images = vehicle_data.images.slice(1);
            console.log(vehicle_data);
            setVehicleData(vehicle_data);
            setVehicleExist(true);
        }
    }, [vehicleVIN, vehiclesByVIN]);

    useEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        // Function to scroll to the section
        const scrollToSection = () => {
            const hash = location.hash;
            if (hash) {
                const element = document.querySelector(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
        };

        // Scroll after a slight delay to ensure DOM updates are complete
        const timeoutId = setTimeout(scrollToSection, 2000);

        // Clean up the timeout if the component unmounts
        return () => clearTimeout(timeoutId);
    }, [vehicleData]);

    // Is Loaded

    const [jsonLd,setJsonLd] = useState({
        "@context": "https://schema.org",
        "@type": ["Product", "Car"],
    });

    const [isDataLoaded, setIsDataLoaded] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setIsDataLoaded(false);
        }, 2000);

        setJsonLd({
            "@context": "https://schema.org/",
            "@type": ["Product", "Car"],
            "@id": vehicleData.stockno,
            "name": vehicleData.vehicle_name,
            "image": vehicleData.vdp_hero_image,
            "description": vehicleData.description,
            "sku": vehicleData.stockno,
            "vehicleInteriorColor": vehicleData.interior_color,
            "vehicleTransmission": vehicleData.transmission,
            "bodyType": vehicleData.body_style,
            "vehicleConfiguration": vehicleData.vehicle_name,
            "brand": {
                "@type": "Brand",
                "name": vehicleData.make
            },
            "model": vehicleData.model,
            "vehicleModelDate": vehicleData.year,
            "itemCondition": "https://schema.org/" + (vehicleData.vehicle_type == "used" ? "Used" : "New") + "Condition",
            "vehicleIdentificationNumber": vehicleData.vin,
            "mpn": vehicleData.vin,
            "color": vehicleData.exterior_color,
            "manufacturer": {
                "@type": "Organization",
                "name": vehicleData.make
            },            
            "mileageFromOdometer": {
                "@type": "QuantitativeValue",
                "value": vehicleData.mileage,
                "unitCode": "SMI"
            }
        })
    }, [vehicleData]);

    // If Vin not Found navigate page 
    useEffect(() => {
        if (!vehicleVIN || !vehiclesByVIN) {
            return;
        }

        // Case-insensitive match
        const match = Object.values(vehiclesByVIN).find(
            (v) => v.vin.toLowerCase() === vehicleVIN.toLowerCase()
        );

        if (!match) {
            navigate("/inventory");
        }
    }, [vehicleVIN, vehiclesByVIN, navigate]);

    // End If Vin not Found navigate page 

    const [tooltipVisible, setTooltipVisible] = useState(false);
    const handleCopy = () => {
        const textArea = document.createElement('textarea');
        textArea.value = vehicleData.vin;
        textArea.style.position = 'absolute';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
            showTooltip();
        } catch (err) {
            console.error('Failed to copy text:', err);
        }
        document.body.removeChild(textArea);
    };

    const showTooltip = () => {
        setTooltipVisible(true);
        setTimeout(() => {
            setTooltipVisible(false);
        }, 2000);
    };


    const scrollToInquire = () => {
        const section = document.getElementById('gotAQuestion');
        section.scrollIntoView({ behavior: 'smooth' });
    };

    const sectionRef = useRef(null);
    const scrollToSection = () => {
        sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const whispAttrs = {
        'data-make': vehicleData.make,
        'data-model': vehicleData.model,
        'data-year': vehicleData.year,
        'data-vin': vehicleData.vin,
        'data-inventorytype': vehicleData.vehicle_type === 'new' ? 'new' : 'used',
        'data-stock': vehicleData.stockno,
    };
    // Mobile view condition
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    console.log("vehicleData", vehicleData)
    const [showAll, setShowAll] = useState(false);
    const visibleItems = showAll ? vehicleData?.options : vehicleData?.options?.slice(0, 6);
    const galleryRef = useRef(null);
    const openGallery = () => {
        const flatImages = vehicleData?.gallery_images?.flat();
        const items = flatImages.map((src) => ({ src, type: "image" }));

        NativeFancybox.show(items);
    };
    console.log("visibleItems", visibleItems)
    // Short Item for desktop 
    const [showMoreDesc, setShowMoreDesc] = useState(false);

    const deskDescItems = vehicleData?.options || [];

    const visibleDskDesc = showMoreDesc
        ? deskDescItems
        : deskDescItems.slice(0, 10);

    const mid = Math.ceil(visibleDskDesc.length / 2);

    const midLength = Math.ceil(deskDescItems.length / 2);

    var srpCarSlider = {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        dots: false,
    };
    UseScrollReveal();
    const galleryWrapRef = useRef(null);
    const [isGalleryNearTop, setIsGalleryNearTop] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (galleryWrapRef.current) {
                const rect = galleryWrapRef.current.getBoundingClientRect();
                if (rect.top <= 200) {
                    setIsGalleryNearTop(true);
                    document.body.classList.add('add-sticky-sec');
                } else {
                    setIsGalleryNearTop(false);
                    document.body.classList.remove('add-sticky-sec');
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    const seoTitle = `${vehicleData?.vehicle_type} ${vehicleData?.vehicle_name} For Sale (${numberFormatter(vehicleData?.price, true)}) | McLaren Orlando LLC Stock #${vehicleData?.stockno}`;
    const seoContent = `${vehicleData?.vehicle_type} ${vehicleData?.vehicle_name} Stock #${vehicleData?.stockno} in Winter Park, FL at McLaren Orlando LLC, FL's premier pre-owned luxury car dealership. Come test drive a ${vehicleData?.make} today!`;

    // Read More Description
    const [expanded, setExpanded] = useState(false);

    const descriptions = vehicleData?.descriptions || [];
    // if (!descriptions.length) return null;

    const limit = 500;

    const fullText = descriptions.join("<br/>");
    const shortText = fullText.substring(0, limit);

    const isLong = fullText.length > limit;

    const descLength = fullText.length;

    const validationSchema = Yup.object().shape({
        full_name: Yup.string()
            .required('Full Name is required'),
        email: Yup.string()
            .email('Invalid email address')
            .required('Email is required'),
        phone: Yup.string()
            .required('Phone number is required'),
        comments: Yup.string()
            .max(500, 'Comments cannot exceed 500 characters'),
        //marketing_agreement: Yup.bool().oneOf([true], 'Terms must be agreed to in order to submit your information'),
        //marketing_info_agreement: Yup.bool().oneOf([true], 'Terms must be agreed to in order to submit your information')
    });

    return (
        <>
            {vehicleExist ?
                <>
                    <SeoMeta
                        const title={seoTitle}
                        description={seoContent}
                        keywords=""
                        ogTitle={seoTitle}
                        ogDescription={seoContent}
                    />
                    <Helmet>
                        <script type="application/ld+json">
                            {JSON.stringify(jsonLd)}
                        </script>
                    </Helmet>
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6Ld25IorAAAAANZCaPfhdftOf511aOBscsnhKulz" // Replace with your actual site key
                        size="invisible"
                    />
                    <section className='vdp-wrap'>
                        <div className='container mxw-1366'>
                            <div className='custom-breadcrumb mb-4 mt-0'>
                                <nav style={{ "--bs-breadcrumb-divider": "'>'" }} aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/inventory">Collections</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">{vehicleData.make}</li>
                                    </ol>
                                </nav>
                            </div>
                            <section className='vdp-banner-wrap mt-0'>
                                <div className='d-flex vdp-banner-flex align-items-center mb-lg-5'>
                                    <div className='w-50 mt-3 wow reveal fadeInUp text-center'>
                                        <img src={vehicleData.vdp_hero_image} alt='hero'
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = getImages(`mclaren-lg-logo.png`);
                                            }}
                                        />
                                    </div>
                                    <div className='w-50 ps-5 wow reveal fadeInUp'>
                                        <div className='d-flex align-items-center mb-4 brand-flex'>
                                            <div className='brand-logo'>
                                                {/* <img src={getImages(`logos/${vehicleData.make}.png`)} /> */}
                                                <img
                                                    src={getMakeImages(`${vehicleData.make}.png`)}
                                                    alt={vehicleData.make}
                                                />
                                            </div>
                                            <div className='brand-name ps-3 text-uppercase'>
                                                {vehicleData.make}
                                            </div>
                                        </div>
                                        <div className='d-flex justify-content-between vdp-banner-info'>
                                            <div>
                                                <div className='vdp-md-title pe-md-3'>
                                                    {vehicleData.year} {vehicleData.model} <span className='vdp-trim'>{vehicleData.trim}</span>
                                                </div>
                                            </div>
                                            <div className='text-end'>
                                                <div className='d-inline-flex align-items-center d-none d-md-block price-sec2'>
                                                    {vehicleData.price > 0 && <span className='xs-title pe-2'>Price</span>}
                                                    <span className='vdp-lg-title'>
                                                        {vehicleData.price > 0 ? priceFormatter(vehicleData.price, true) : <a href='tel:4079880111' className='xs-title text-white'>CALL FOR PRICE</a>}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='d-flex align-items-center justify-content-between vdp-banner-info pt-md-3'>
                                            <div className='mb-2 mb-md-0'>
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <div className='d-xl-flex align-items-center'>
                                                        <div className='mb-md-2 mb-xl-0'>
                                                            <span className='location-tag'><img src={getImages('pin-icon.svg')} /> Winter Park</span>
                                                        </div>
                                                        <div className='sm-title mob-vdp-miles ps-md-4'>
                                                            Miles:&nbsp;
                                                            {numberFormatter(vehicleData.mileage)}
                                                        </div>
                                                    </div>
                                                    <div className='d-md-none'>
                                                        <div className='d-inline-flex align-items-center mb-3 mb-4 price-sec2 mob-price-sec2'>
                                                            {vehicleData.price > 0 && <span className='xs-title pe-md-2'>Price</span>}
                                                            <span className='vdp-lg-title'>
                                                                {vehicleData.price > 0 ? priceFormatter(vehicleData.price, true) : <a href='tel:4079880111' className='xs-title text-white'>CALL FOR PRICE</a>}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='text-end d-flex flex-column flex-md-row gap-2 vdp-cta-group'>
                                                <button className='btn-black-theme inquire-btn text-white btn-tap-text' type='button' data-pid='fc83dec4' {...whispAttrs}>Inquire</button>
                                                <button className='btn-black-theme inquire-btn text-white btn-tap-text' type='button' data-pid='fff84477' {...whispAttrs}>Tap to Text</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div className={`sticky-section ${!isGalleryNearTop ? 'd-none' : ''}`}>
                            <div className='container mxw-1366'>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div className='d-flex align-items-center wow reveal fadeInLeft'>
                                        <div className='me-lg-3 me-2'><img className="mcleran-icon" src={getImages('mclaren-svgrepo-com.svg')} /></div>
                                        <div className='lg-title fw-300 font-1-9em pe-3'>
                                            {vehicleData.year} {vehicleData.model} {vehicleData.trim}</div>
                                    </div>
                                    <div className='d-flex align-items-center vdpn-b-right wow reveal fadeInRight'>
                                        {vehicleData.price > 0 && <div className='xxs-title fw-500 text-white me-3 d-lg-block d-none'>Price</div>}
                                        <div className='lg-title fw-500 font-1-9em me-xl-5 me-3 pt-2  d-lg-block d-none'>
                                            {vehicleData.price > 0 ?
                                                priceFormatter(vehicleData.price, true) :
                                                <a href='tel:4079880111' className='xs-title text-white'>CALL FOR PRICE</a>}
                                        </div>
                                        <div className='d-flex gap-2'>
                                            <button type='button' className='theme-btn text-uppercase fw-500 d-inline-block w-240 btn-tap-text' data-pid='fc83dec4' {...whispAttrs}>Inquire</button>
                                            <button type='button' className='theme-btn text-uppercase fw-500 d-none d-sm-inline-block w-240 btn-tap-text' data-pid='fff84477' {...whispAttrs}>Tap to Text</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section className='vdp-gallery-wrap pt-4' ref={galleryWrapRef}>
                            <div className='container mxw-1366'>
                                <div className='vdp-gallery-tab wow reveal fadeInUp'>
                                    {vehicleData.gallery_images.length > 0 && <Fancybox
                                        options={{
                                            Carousel: {
                                                infinite: false,
                                            },
                                        }}
                                    >
                                        {isMobile ?
                                            <div className='row g-3'>
                                                {vehicleData.gallery_images.slice(0, 3).map((v, i) => {
                                                    return v.map((w, j) => {
                                                        const uniqueKey = `${i}-${j}`;
                                                        return (
                                                            <div className='col-6' key={uniqueKey}>
                                                                <div className='gallery-box'>
                                                                    <a
                                                                        data-fancybox="gallery_1"
                                                                        ref={i === 0 && j === 0 ? galleryRef : null}
                                                                        href={w}
                                                                        className='position-relative'
                                                                    >
                                                                        <img src={w} alt='thumb' />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        );
                                                    });
                                                })}

                                                <div className='col-12 text-center mt-4'>
                                                    <button type='button' className='photo-count'
                                                        onClick={openGallery}
                                                    ><img src={getImages('photo-camera-icon.png')} /> {vehicleData.gallery_images.flat().length}+</button>
                                                </div>
                                            </div>
                                            : <Slider className="gallery-slider common-arrow" {...srpCarSlider}>
                                                {vehicleData.gallery_images.map((v, i) => {
                                                    return (
                                                        <div className='item' key={i}>
                                                            {v.map((w, j) => {
                                                                return (
                                                                    <div className='gallery-box mb-4' key={j}>
                                                                        <a data-fancybox="gallery" href={w} className='position-relative'>
                                                                            <img src={w} alt='thumb' />
                                                                        </a>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    );
                                                })}
                                            </Slider>}
                                    </Fancybox>}
                                </div>
                            </div>
                        </section>
                        {(vehicleData?.descriptions?.length > 0 || vehicleData?.options?.length > 0) && (
                            <section className='vdp-list-wrap'>
                                <div className='container mxw-1366'>
                                    {console.log("isLong", isLong)}
                                    {console.log("expanded", expanded)}
                                    <>
                                        {(vehicleData?.descriptions?.length > 0 || vehicleData?.options?.length > 0) &&
                                            <>
                                                <div className="vdp-description pb-5 wow reveal fadeInUp">
                                                    <p>
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: expanded ? fullText : shortText + (isLong ? "..." : "")
                                                            }}
                                                        />
                                                        {!expanded &&
                                                            vehicleData?.descriptions?.length > 0 &&
                                                            vehicleData?.options?.length > 0 &&
                                                            isLong && (
                                                                <span
                                                                    onClick={() => setExpanded(!expanded)}
                                                                    className="ms-2 text-orange"
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    {expanded ? "Read Less" : "Read More"}
                                                                </span>
                                                            )}

                                                        {vehicleData?.descriptions?.length > 0 &&
                                                            vehicleData?.options?.length === 0 &&
                                                            isLong && (
                                                                <span
                                                                    onClick={() => setExpanded(!expanded)}
                                                                    className="ms-2 text-orange"
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    {expanded ? "Read Less" : "Read More"}
                                                                </span>
                                                            )}
                                                    </p>
                                                </div>
                                                {!expanded ? "" :
                                                    <>
                                                        <div className='d-flex vdpl-flex vdpl-desktop-flex wow reveal fadeInUp'>
                                                            <ul className='vdp-list pe-3'>
                                                                {deskDescItems?.slice(0, midLength).map((item, index) => (
                                                                    <li key={index}>{item}</li>
                                                                ))}
                                                            </ul>
                                                            <ul className='vdp-list ps-3'>
                                                                {deskDescItems?.slice(midLength).map((item, index) => (
                                                                    <li key={index}>{item}</li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                        {vehicleData?.options?.length > 0 && (
                                                            <div className="mt-2 wow reveal fadeInUp">
                                                                <button
                                                                    className="view-more-btn"
                                                                    onClick={() => setExpanded(!expanded)}
                                                                >
                                                                    {expanded ? "View Less" : "View More"}
                                                                </button>
                                                            </div>
                                                        )}
                                                    </>
                                                }
                                            </>
                                        }
                                        {/* {vehicleData?.descriptions?.length > 0 &&
                                            vehicleData?.options?.length === 0 && (
                                                <div className="vdp-description pb-5 wow reveal fadeInUp">
                                                    <p>
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: expanded ? fullText : shortText + (isLong ? "..." : "")
                                                            }}
                                                        />

                                                        {isLong && (
                                                            <span
                                                                onClick={() => setExpanded(!expanded)}
                                                                className="ms-2 text-orange"
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                {expanded ? "Read Less" : "Read More"}
                                                            </span>
                                                        )}
                                                    </p>
                                                </div>
                                            )} */}
                                        {((!vehicleData?.descriptions || vehicleData?.descriptions.length === 0 || descLength < 500) &&
                                            vehicleData?.options?.length > 0) && (
                                                isMobile ? (
                                                    <div className='vdpl-flex wow reveal fadeInUp'>
                                                        <ul className="vdp-list">
                                                            {visibleItems.map((item, index) => (
                                                                <li key={index}>{item}</li>
                                                            ))}
                                                        </ul>

                                                        {vehicleData?.options?.length > 6 && (
                                                            <button
                                                                className="view-more-btn"
                                                                onClick={() => setShowAll(!showAll)}
                                                            >
                                                                {!showAll ? 'View More' : 'View Less'}
                                                            </button>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className='d-flex vdpl-flex vdpl-desktop-flex wow reveal fadeInUp'>
                                                            <ul className='vdp-list pe-3'>
                                                                {visibleDskDesc.slice(0, mid).map((item, index) => (
                                                                    <li key={index}>{item}</li>
                                                                ))}
                                                            </ul>

                                                            <ul className='vdp-list ps-3'>
                                                                {visibleDskDesc.slice(mid).map((item, index) => (
                                                                    <li key={index}>{item}</li>
                                                                ))}
                                                            </ul>
                                                        </div>

                                                        {vehicleData?.options?.length > 10 && (
                                                            <div className="mt-2 wow reveal fadeInUp">
                                                                <button
                                                                    className="view-more-btn"
                                                                    onClick={() => setShowMoreDesc(!showMoreDesc)}
                                                                >
                                                                    {showMoreDesc ? "View Less" : "View More"}
                                                                </button>
                                                            </div>
                                                        )}
                                                    </>
                                                )
                                            )}
                                    </>
                                </div>
                            </section>
                        )}
                        <section className='vdp-content-wrap'>
                            <div className='container mxw-1366'>
                                <div className='vdpa-block pt-5 row'>
                                    <div className='col-lg-4 order-lg-2 mb-3 mb-lg-0'>
                                        <div className='vdpa-box p-4'>
                                            <div className='md-title text-uppercase mb-3 wow reveal fadeInUp'>Vehicle Info</div>
                                            <div className='vdpa-table'>
                                                <table className='w-100'>
                                                    <tbody>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Stock</th>
                                                            <td>{vehicleData.stockno}</td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>VIN</th>
                                                            <td className="text-nowrap">
                                                                <span className='position-relative copy-info'>
                                                                    <span className='copy_icon' onClick={handleCopy} style={{ cursor: 'pointer' }}></span>
                                                                    {tooltipVisible && <span className='copy-tooltip'>Copied!</span>}
                                                                </span>
                                                                {vehicleData.vin}
                                                            </td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Year</th>
                                                            <td>{vehicleData.year}</td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Make</th>
                                                            <td>{vehicleData.make}</td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Model</th>
                                                            <td>{vehicleData.model}</td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Trim</th>
                                                            <td>{vehicleData.trim}</td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Mileage</th>
                                                            <td>{numberFormatter(vehicleData.mileage)}</td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Body Style</th>
                                                            <td>{vehicleData.body_style}</td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Exterior Color</th>
                                                            <td>{vehicleData.exterior_color}</td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Interior Color</th>
                                                            <td>{vehicleData.interior_color}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className='mt-md-4 mt-3 mb-2 wow reveal fadeInUp'>
                                                <div className='text-center carfax-tag'>
                                                    <a href={'http://www.carfax.com/VehicleHistory/p/Report.cfx?partner=DVW_1&vin=' + vehicleData.vin} target="_blank">
                                                        <img src={getImages('carfax-tag.jpg')} alt='carfax' />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-8' id="aboutVdp">
                                        <div className='vdpa-box vdpa-about-box h-100'>
                                            <div className='md-title text-uppercase mb-3 wow reveal fadeInUp'>About this Vehicle</div>
                                            <p className='wow reveal fadeInUp' dangerouslySetInnerHTML={{ __html: vehicleData.description }}></p>
                                            <div id="gotAQuestion" ref={sectionRef} >
                                                <div className='md-title mt-2 pt-5 mb-90 wow reveal fadeInUp'>Got a question? <a href="#" className='text-theme'>Call</a> or <a href="#" className='text-theme'>Chat</a> live with a sales representative</div>
                                                <Formik
                                                    validationSchema={validationSchema}
                                                    initialValues={{
                                                        full_name: '',
                                                        email: '',
                                                        phone: '',
                                                        comment: '',
                                                        vin: vehicleData.stockno,
                                                        year: vehicleData.year,
                                                        make: vehicleData.make,
                                                        model: vehicleData.model,
                                                        trim: vehicleData.trim,
                                                        mileage: vehicleData.mileage,
                                                        exterior: vehicleData.exterior_color,
                                                        marketing_agreement: false,
                                                        marketing_info_agreement: false
                                                    }}
                                                    onSubmit={async (values, { resetForm }) => {
                                                        const token = await recaptchaRef.current.executeAsync();
                                                        recaptchaRef.current.reset(); // Reset after use

                                                        values.token = token;

                                                        console.log(values);
                                                        const data = await submitContactForm(values);

                                                        if (data.success) {
                                                            resetForm();
                                                            navigate("/thank-you");
                                                            // alert("Thank you for your submission. We'll be in touch soon!");
                                                        } else
                                                            alert("There was a problem with your submission");
                                                    }}
                                                >
                                                    {({ values, setFieldValue, field, form }) => (
                                                        <Form className="custom-form vdp-contact-form" autoComplete="off" name="contact-form">
                                                            <Field type="hidden" name="vin" value={vehicleData.vin} />
                                                            <Field type="hidden" name="year" value={vehicleData.year} />
                                                            <Field type="hidden" name="make" value={vehicleData.make} />
                                                            <Field type="hidden" name="model" value={vehicleData.model} />
                                                            <Field type="hidden" name="trim" value={vehicleData.trim} />
                                                            <Field type="hidden" name="mileage" value={vehicleData.mileage} />
                                                            <Field type="hidden" name="exterior" value={vehicleData.exterior_color} />
                                                            <div className='row'>
                                                                <div className='col-md-6 wow reveal fadeInUp'>
                                                                    <div className='form-group mb-3'>
                                                                        <div className='d-flex align-items-center justify-content-between mb-2'>
                                                                            <div className='cs-label mb-0'>Full Name</div>
                                                                            <div className='cs-require'>* Required</div>
                                                                        </div>
                                                                        <Field
                                                                            type="text"
                                                                            name="full_name"
                                                                            className="form-control"
                                                                            required />
                                                                        <ValidationError name="full_name" />
                                                                    </div>
                                                                    <div className='form-group mb-3'>
                                                                        <div className='d-flex align-items-center justify-content-between mb-2'>
                                                                            <div className='cs-label mb-0'>Email</div>
                                                                            <div className='cs-require'>* Required</div>
                                                                        </div>
                                                                        <Field
                                                                            type="text"
                                                                            name="email"
                                                                            className="form-control"
                                                                            required />
                                                                        <ValidationError name="email" />
                                                                    </div>
                                                                    <div className='form-group mb-3'>
                                                                        <div className='cs-label mb-2'>Phone Number</div>
                                                                        <div className='cs-require'>* Required</div>
                                                                        <Field
                                                                            type="text"
                                                                            name="phone"
                                                                            className="form-control"
                                                                            required />
                                                                        <ValidationError name="phone" />
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-6 wow reveal fadeInUp'>
                                                                    <div className='form-group mb-3'>
                                                                        <div className='cs-label mb-2'>Comments</div>
                                                                        <Field
                                                                            type="text"
                                                                            name="comment"
                                                                            className="form-control h-218"
                                                                            component="textarea" />
                                                                        <ValidationError name="comment" />
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 wow reveal fadeInUp">
                                                                    <div className='form-group marketing-agree'>
                                                                        <div className="custom-checkbox fin_app_chkbox ">
                                                                            <Field
                                                                                type="checkbox"
                                                                                name="marketing_agreement"
                                                                                // value="agree" 
                                                                                id="iAgreeChk"
                                                                            />
                                                                            <label htmlFor="iAgreeChk"  className="cs-label fw-400 font-12 pt-1">Yes, I agree to receive marketing/promotional SMS messages from McLaren Orlando, including special offers, exclusive incentives, event invitations, and dealership news.</label>
                                                                        </div>
                                                                        <ValidationError name="marketing_agreement" />
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 wow reveal fadeInUp">
                                                                    <div className='form-group marketing-agree'>
                                                                        <div className="custom-checkbox fin_app_chkbox ">
                                                                            <Field
                                                                                type="checkbox"
                                                                                name="marketing_info_agreement"
                                                                                // value="agree" 
                                                                                id="iAgreeChk2"
                                                                            />
                                                                            <label htmlFor="iAgreeChk2"  className="cs-label fw-400 font-12 pt-1">Yes, I agree to receive informational/transactional SMS messages from McLaren Orlando, such as appointment reminders, service updates, vehicle status notifications, and important account-related information.</label>
                                                                        </div>
                                                                        <ValidationError name="marketing_info_agreement" />
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 wow reveal fadeInUp">
                                                                    <div className='form-group'>
                                                                        <div className="custom-checkbox fin_app_chkbox mb-4">
                                                                            <div  className="cs-label fw-400 font-12 pt-1 custom-breadcrumb">By providing your mobile number and checking the above box/es, you agree to related text messages from McLaren Orlando at the phone number you provided when signing up. Reply STOP to unsubscribe, Reply HELP for help. Message frequency varies. Message & data rates may apply. Consent is not a condition of purchase. For more information, please review our Privacy Policy <Link to="https://cars.mclaren.com/us_en/privacy-policy">Privacy Policy</Link> and <Link to="https://cars.mclaren.com/us_en/terms-conditions">Terms of Service</Link></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='row mt-3 justify-content-between about-action-flex wow reveal fadeInUp'>

                                                                <div className='col-md-6 text-end order-md-2'>
                                                                    <button className='theme-btn text-uppercase w-300'>Send</button>
                                                                </div>
                                                                <div className='col-md-6 fb-contact-info'>
                                                                    <a href='tel:4079880111' className='d-inline-flex align-items-center phone-no-text mb-2'>
                                                                        <span className='fw-400 '><span className='call-icon'><img src={getImages('call.png')} alt='call' /></span></span>
                                                                        <span className='ps-md-3 ps-2'>407-988-0111</span>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </Form>
                                                    )}
                                                </Formik>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </section>
                </>
                :
                <section className='vdp-wrap mnh-90vh'></section>
            }
        </>
    )
}

export default Vdp